import { render, staticRenderFns } from "./paySteps.vue?vue&type=template&id=675e77ca&scoped=true"
import script from "./paySteps.vue?vue&type=script&lang=js"
export * from "./paySteps.vue?vue&type=script&lang=js"
import style0 from "./paySteps.vue?vue&type=style&index=0&id=675e77ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675e77ca",
  null
  
)

export default component.exports